///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { data } from 'jquery';

@Component({
    templateUrl: './AppViews/WeeklyPlan/WeeklyPlan.html'
})

export class WeeklyPlanComponent implements OnInit {
    showLoader = false;
    invalidRecord: boolean = false;
    constants: Constants;
    timesheetDetails: any = {};
    projectList: any = [];
    TaskList: any = [];
    timesheetItems: any = [];
   // weeklyplanItems: any = [];
    userDetail: any;
    userList: any = [];
    teamList: any = [];
    public week: any[] = [];
    selectedWeek:any;
    dateRangeLabel:string='';
    startDate:string='';
    endDate:string='';
    objTotalTimeSpent: any = 0;
    WeeklyPlan: any = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY'),'TeamId': "",
                      'UserId': "",'WeekId': "" ,'Year': moment().format('YYYY'),'TaskTypeId':"",'selectedWeek':"",'LoggedInProfileId':"",'NoOfDays':"5"};
    addTimesheet: any = {};
    addTimesheetFormActive: any = true;
    newItem = { 'ProjectId': "", 'TaskTypeId': "", 'EstimatedTime': 0, 'Comments': "", 'TaskList': [],'NoOfDays':"" };
    getProjectUrl: any;
    teamItems:any[]=[];
    isDisable: boolean = false;
    filter: any = {};
    //selectedDay: number=5;
    days: number[]=[1,2,3,4,5,6,7];
    
    WeeklyPlanList: any =  [JSON.parse(JSON.stringify(this.newItem)), JSON.parse(JSON.stringify(this.newItem)), JSON.parse(JSON.stringify(this.newItem)), JSON.parse(JSON.stringify(this.newItem))];
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        //this.filter = { 'Year': moment().format('YYYY')};
    }

    ngOnInit() {
        
        //this.GetProjectList();
       // this.GetUserListbyproj();      
        this.GetteamList();
        this.getWeek();
        this.GetUserList();
       
    }


    ngAfterViewInit() {
        var today = moment().format('YYYY-MM-DD');
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY',
            maxDate: today
        });

        $(".dateYear").datetimepicker({
            format: 'YYYY'
            //maxDate:moment().set({hour:0,minute:0,second:0,millisecond:0})
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

       

    }

    ngAfterViewChecked() {
        if (this.projectList.length > 0) {
            $('.dataSearch').selectpicker({
                style: 'btn-info',
                size: 4
            });

            $('.selectPicker').selectpicker({ style: 'btn-info' });
        }


    }

    public changeYear(event){
        debugger;
        this.WeeklyPlan.Year = event.srcElement.value;
        this.getWeek();
    }

//    public changeDay(event:any):void{
//         console.log('selected day:',this.WeeklyPlan.selectedDay);
//     }

    public clearFilter() {
        //$(".dataSearch").val('').selectpicker('refresh');
        this.WeeklyPlan = { 'FromDate': moment().format('DD/MM/YYYY') };
        this.WeeklyPlan = { 'Year': moment().format('YYYY')};
    }
    // public clearFilter() {
    //     this.filter = { 'Year': moment().format('YYYY')};
    // }

    GetProjectList() {
        this.showLoader=true;
        var UserId = 0;
        var TeamId = 0;
        /*
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;          
                 TeamId=0          
        }
        */
        UserId= this.WeeklyPlan.UserId;
        this._httpService.ajaxPost("Project/GetAssignedProject",
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 0, "UserId": UserId }).subscribe(
            data => {
                this.projectList = data["ProjectList"]; 
                this.showLoader=false;               
            },
            err => { console.log("GetProjectList Failed");this.showLoader=false;},
            );
    }

    GetTaskList(val, index) {     
        debugger;  
        if (val == "") {
            this.WeeklyPlanList[index].TaskList = [];
            this.WeeklyPlanList[index].TaskTypeId = '';
        }
        else {
            //get task type list from taskGroupList from projecttaskGroup by project type of project id
            //projectId->projectType->projectTaskGroupList->projectTaskTypeList
            //this.filter.UserId = this.siteUserItems.filter((item) => item.TeamID == val)[0].Site_UserId;
            this.showLoader=true;
            this._httpService.ajaxPost("TaskType/GetTaskTypeByProjectId",
                { "ProjectId": val }).subscribe(
                data => {
                    this.WeeklyPlanList[index].TaskList = data["TaskTypeList"];
                },
                err => {
                    this.showLoader=false;
                },
                () =>{
                    this.showLoader=false;
                }
                );
        }
    }
    

    GetTotalTimeSpent() {
        this.objTotalTimeSpent = 0
        this.WeeklyPlanList.forEach(element => {
            if (element.EstimatedTime == "") {
                element.EstimatedTime = 0;
            }
            
            this.objTotalTimeSpent += parseInt(element.EstimatedTime);
            
        });
    }

    
    public getWeek() {
        debugger
        this.showLoader = true;
        this._httpService.ajaxPost('Week/GetWeek', 
                  { "Year": this.WeeklyPlan.Year
                  }).subscribe(
            data => {
                this.week = data["Week"];
                
                
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
    
    OnWeekSelect()
    {
        debugger;
        if (this.WeeklyPlan.WeekId != "" ) {
            var result = this.week.filter(x=>x.WeekId == this.WeeklyPlan.WeekId)[0];
            this.startDate = new Date(result.WeekFirstDate).toLocaleDateString();
             this.endDate = new Date(result.WeekLastDate).toLocaleDateString();
        
            this.dateRangeLabel = this.startDate+ ' to ' + this.endDate;
          } else {
            this.dateRangeLabel = ''; 
          }
    }

    GetUserList() {
      
        console.log("wwwwwwwwwwww");
        //   this.filter.UserId="";
       this.showLoader = true;
       this._httpService.ajaxPost("Users/GetUsers",
            {
               "IsActive": this.constants.enumUserStatus["Active"],
            //     "Role": null,
            //    "Site": null,
                "Team": this.userDetail.TeamID,
               "UserId": this.userDetail.SiteUserId
           }).subscribe(
           data => {
            debugger
               this.userList = data["Users"];
              $(".project").val('').selectpicker('refresh');
         },
         err => {
               console.log("GetUserList Failed");
             this.showLoader = false;
          },
         () => {
                this.showLoader = false;
            }
           );
    }

    // GetUserListbyproj() {
    //     debugger;
    //     //   this.filter.UserId="";
    //     var teamId= this.userDetail.TeamID;
        
    //     this.showLoader = true;
    //     this._httpService.ajaxPost("TimeSheet/GetUsersByProject",
    //         {   "Project_Id": 0,
    //             "IsActive": this.constants.enumUserStatus["Active"],
    //             "Team_Id":teamId,
    //             "ProjectType": 0,
    //             "Status": 1,
    //             "UserId": this.userDetail.SiteUserId
    //         }).subscribe(
    //         data => {
    //            // this.userList = data["Users"];
    //             $(".project").val('').selectpicker('refresh');
    //         },
    //         err => {
    //             console.log("GetUserList Failed");
    //             this.showLoader = false;
    //         },
    //         () => {
    //             this.showLoader = false;
    //         }
    //         );
    // }

    GetteamList() {
        // this.filter.UserId="";
        this.showLoader = true;
        //   this.filter.UserId="";
        this._httpService.ajaxPost("Team/GetAssignedTeam", { "TeamId": this.userDetail.TeamID, "UserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.teamList = data["AssignedTeam"];
            },
            err => {
                console.log("GetTeamList Failed");
                this.showLoader = false;
            },
            () => {
              //  this.GetUserListbyproj();
                this.showLoader = false;
            }
        );
    }


    AddRecord() {
        //add new record to timesheet grid
        this.WeeklyPlanList.push(JSON.parse(JSON.stringify(this.newItem)));
    }

    DeleteRecord(index) {
        //delete record to timesheet grid
        this.WeeklyPlanList.splice(index, 1);
        this.GetTotalTimeSpent();
    }

    ValidateWeeklyPlan(controlName, index) {
        debugger;
        if (controlName == "" && index == 0) {
            this.invalidRecord = false;
            for (var i = 0; i < this.WeeklyPlanList.length; i++) {
                var ProjectId = $('#ProjectId' + i).val();
                var TaskTypeId = $('#TaskTypeId' + i).val();
                var EstimstedTime = $('#EstimstedTime' + i).val();
                var Comments = $('#Comments' + i).val();

                var isNumber = /^\d+$/.test(EstimstedTime);
                if (ProjectId == "" && TaskTypeId == "" && (EstimstedTime == "" || EstimstedTime == "0" || isNumber == false) && Comments == "") {
                    $('#ProjectId' + i).siblings(".btn-info").removeAttr("style");
                    $('#TaskTypeId' + i).siblings(".btn-info").removeAttr("style");
                    $('#EstimatedTime' + i).parent().removeClass("has-error");
                    $('#Comments' + i).parent().removeClass("has-error");
                }
                else {
                    if (ProjectId == "") {
                        this.invalidRecord = true;
                        $('#ProjectId' + i).siblings(".btn-info").attr("style", "border-color:#a94442 !important");
                    }

                    if (TaskTypeId == "") {
                        this.invalidRecord = true;
                        $('#TaskTypeId' + i).siblings(".btn-info").attr("style", "border-color:#a94442 !important");
                    }

                    if (EstimstedTime == "" || EstimstedTime == "0" || isNumber == false) {
                        this.invalidRecord = true;
                        $('#EstimatedTime' + i).parent().addClass("has-error");
                    }
                    else {
                        if (isNaN(EstimstedTime)) {
                            this.invalidRecord = true;
                            $('#EstimatedTime' + i).parent().addClass("has-error");
                        }
                    }

                    if (Comments == "") {
                        this.invalidRecord = true;
                        $('#Comments' + i).parent().addClass("has-error");
                    }
                    
                }
            }
            if (!this.invalidRecord) {
                this.AddWeekPlan();
            }
        }
        else {
            var Control = $('#' + controlName + index).val();
            var isNo = /^\d+$/.test(Control);
            if (Control == "" || Control == "0") {
                this.invalidRecord = true;
                $('#' + controlName + index).parent().addClass("has-error");
                $('#' + controlName + index).siblings(".btn-info").attr("style", "border-color:#a94442 !important");
            }
            else {
                if (controlName == "EstimatedTime" && isNo == false) {
                    $('#' + controlName + index).parent().addClass("has-error");
                }
                else {
                    $('#' + controlName + index).parent().removeClass("has-error");
                    $('#' + controlName + index).siblings(".btn-info").removeAttr("style");
                }

            }
        }

    }

    AddWeekPlan() {
        debugger
        console.log(this.WeeklyPlanList);
        
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.WeeklyPlan));
        objItem.LoggedInProfileId = this.userDetail.SiteUserId;
       // objItem.NoOfDays=this.WeeklyPlan.selectedDay;
       // objItem.TaskTypeId=this.WeeklyPlan.TaskTypeId;
        objItem.WeekPlanList = this.WeeklyPlanList.filter(x=>x.ProjectId != "" );
        if (objItem.WeekPlanList.length > 0) {
            //let objTimesheet: any = { "WeeklyPlanList": objItem };
            this._httpService.ajaxPost('Week/AddUpdateWeekPlan', objItem).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        //if (message[0] == "warning") {
                        //    //vm.isWarning = true;
                        //}
                        msg[0] = msg[0].toLowerCase();
                        //this._toasterService.pop(msg[0], msg[1]);
                        this._sharedService.ShowMessage(data["Status"].Message);

                        this._route.navigateByUrl("/WeeklyPlan");
                    }
                    else {
                        //this._toasterService.pop('success', msg);
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                }
            );
        }
        else {
            this._sharedService.ShowMessage("error|Enter atleast one record");
        }
    }

    GetWeeklyPlan() {
        debugger;
        if( this.WeeklyPlan.WeekId != "" && this.WeeklyPlan.UserId != "" )
        {
        this.showLoader=true;
        this.isDisable = false;
        this._httpService.ajaxPost("Week/GetWeeklyPlan",
            {
                "WeekId": this.WeeklyPlan.WeekId,
                "UserId": this.WeeklyPlan.UserId           
            }).subscribe(
            data => {
                this.WeeklyPlanList = data["WeeklyPlanList"];
                if(this.WeeklyPlanList .length > 0)
                this.WeeklyPlan.NoOfDays = this.WeeklyPlanList[0].NoOfDays; 
            else
                this.WeeklyPlan.NoOfDays =5;
                // this.WeeklyPlanList = [];
                // for (var i = 0; i < this.weeklyplanItems.length; i++) {
                //     var iItem = { 'ProjectId': "", 'TaskTypeId': "", 'EstimatedTime': 0, 'Comments': "", 'TaskList': [],'NoOfDays':"" };                  
                //     iItem.ProjectId = this.weeklyplanItems[i].ProjectId;
                //     this.GetTaskList(iItem.ProjectId,i);
                //     iItem.TaskTypeId = this.weeklyplanItems[i].TaskTypeId;
                //     iItem.EstimatedTime = this.weeklyplanItems[i].EstimatedTime;
                //     iItem.Comments = this.weeklyplanItems[i].Comments;
                //     this.WeeklyPlan.NoOfDays = this.weeklyplanItems[i].NoOfDays;                 
                //     this.WeeklyPlanList.push(iItem);
                // }
                 var count = 0;
                if (this.WeeklyPlanList.length <= 3) {
                    count = (3 - this.WeeklyPlanList.length);
                }
                for (var i = 0; i < count; i++) {
                    this.WeeklyPlanList.push(JSON.parse(JSON.stringify(this.newItem)));
                }
                console.log("RRPP"+ JSON.stringify( this.WeeklyPlanList));
                this.GetTotalTimeSpent();
                this.showLoader=false;
            } ,
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
                }
        
            );
        }else{
            this.WeeklyPlan.NoOfDays  = 5;
            this.WeeklyPlanList =[];
            var count = 3;
            for (var i = 0; i < count; i++) {
                this.WeeklyPlanList.push(JSON.parse(JSON.stringify(this.newItem)));
            }
        }
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/WeeklyPlan/WeeklyPlan.component.ts
 **/